<template>
    <div class="staff-box" ref="staffBox">
        <!--<el-tooltip class="item" effect="dark" :content="staffLabel" placement="top-start">-->
            <!--<el-button type="text" class="staff-btn" @click="isShowSelect = true" v-html="staffLabel"></el-button>-->
        <!--</el-tooltip>-->

        <el-button type="text" class="staff-btn" @click="isShowSelect = true" v-html="staffLabel"></el-button>

        <!--选择盒子-->
        <cash-staff-select-box v-model="isShowSelect" @selected="handleSelect" :selectedStaff="staffList" :pro-type="item.pro_type" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopSelect from "@/model/PopSelect";
    import CashStaffSelectBox from "@/model/Cash/CashStaffSelectBox";
    export default {
        name: "SelectStaff",
        components: {CashStaffSelectBox, PopSelect},
        props: ["item"],
        data: () => ({
            isShowSelect: false,
            staffLabel: "无",
            staffList: []
        }),
        mounted: function(){

        },
        methods: {
            //更新
            updateSelect: function (staffArr) {
                if(!obj.isEmpty(staffArr)) {
                    let label = [];
                    staffArr.forEach(val => {
                        label.push(val.work_id+val.name);
                    });
                    this.staffLabel = label.join("</br>");
                    this.staffList = staffArr;
                }else{
                    this.staffLabel = "无";
                    this.staffList = [];
                }
            },
            //选择之后
            handleSelect: function (staffArr) {
                this.updateSelect(staffArr);
                this.$emit("selected", staffArr);
            }
        },
        watch: {
            "item.staff": function (val) {
                this.updateSelect(val);
            },
            "item": function (val) {
                this.updateSelect(val.staff);
            }
        }
    }
</script>

<style scoped>
    .staff-btn{
        border: none;
        padding-top: 11px;
        padding-bottom: 11px;
        line-height: 22px;
        width: 100px;
        overflow: hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
        text-align: left;
        color: #333333;
    }
</style>
